<template>
	<div class="addEdit-block" :style='{"padding":"30px","fontSize":"16px","color":"#666","background":"none"}'>
		<el-form
			:style='{"border":"1px solid #eee","padding":"30px","boxShadow":"0 0px 0px rgba(64, 158, 255, .3)","fontSize":"inherit","borderRadius":"6px","background":"#fff"}'
			class="add-update-preview"
			ref="ruleForm"
			:model="ruleForm"
			:rules="rules"
			label-width="150px"
		>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'"  label="分类名称" prop="categoryName">
				<el-input  v-model="ruleForm.categoryName" placeholder="分类名称" clearable  :readonly="ro.categoryName"></el-input>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="分类名称" prop="categoryName">
				<el-input v-model="ruleForm.categoryName" placeholder="分类名称" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="textarea" v-if="type!='info'" label="分类描述" prop="categoryDesc">
				<el-input
				  style="min-width: 200px; max-width: 600px;"
				  type="textarea"
				  :rows="4"
				  placeholder="分类描述"
				  v-model="ruleForm.categoryDesc" >
				</el-input>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else-if="ruleForm.categoryDesc" label="分类描述" prop="categoryDesc">
				<span :style='{"fontSize":"inherit","lineHeight":"40px","color":"inherit","fontWeight":"500","display":"inline-block"}'>{{ruleForm.categoryDesc}}</span>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'"  label="排序序号" prop="sortOrder">
				<el-input-number v-model="ruleForm.sortOrder" :min="0" :max="999" placeholder="排序序号" :readonly="ro.sortOrder"></el-input-number>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="排序序号" prop="sortOrder">
				<el-input v-model="ruleForm.sortOrder" placeholder="排序序号" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="是否启用" prop="isEnable">
				<el-select v-model="ruleForm.isEnable" placeholder="请选择是否启用">
					<el-option label="启用" :value="1"></el-option>
					<el-option label="禁用" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="是否启用" prop="isEnable">
				<el-tag v-if="ruleForm.isEnable==1" type="success">启用</el-tag>
				<el-tag v-else type="danger">禁用</el-tag>
			</el-form-item>
			
			<el-form-item :style='{"width":"100%","padding":"0","margin":"0","fontSize":"inherit","textAlign":"center"}' class="btn">
				<el-button class="btn3"  v-if="type!='info'" type="success" @click="onSubmit">
					<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
					保存
				</el-button>
				<el-button class="btn4" v-if="type!='info'" type="success" @click="back()">
					<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					取消
				</el-button>
				<el-button class="btn5" v-if="type=='info'" type="success" @click="back()">
					<span class="icon iconfont icon-fanhui" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					返回
				</el-button>
			</el-form-item>
		</el-form>
  </div>
</template>
<script>
export default {
	data() {
		return {
			id: '',
			type: '',
			ro: {
				categoryName: false,
				categoryDesc: false,
				sortOrder: false,
				isEnable: false
			},
			ruleForm: {
				categoryName: '',
				categoryDesc: '',
				sortOrder: 0,
				isEnable: 1
			},
			rules: {
				categoryName: [
					{ required: true, message: '分类名称不能为空', trigger: 'blur' }
				],
				sortOrder: [
					{ required: true, message: '排序不能为空', trigger: 'blur' }
				]
			}
		};
	},
	props: ["parent"],
	computed: {},
	created() {},
	mounted() {},
	methods: {
		init(id, type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if (this.type == 'info' || this.type == 'else') {
				this.info(id);
			} else if (this.id) {
				this.info(id);
			}
		},
		// 获取信息
		info(id) {
			this.$http({
				url: `articleCategory/info/${id}`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data;
				}
			});
		},
		// 提交
		onSubmit() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					this.$http({
						url: `articleCategory/${!this.ruleForm.id ? "save" : "update"}`,
						method: "post",
						data: this.ruleForm
					}).then(({ data }) => {
						if (data && data.code === 0) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.parent.showFlag = true;
									this.parent.search();
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					});
				}
			});
		},
		// 返回
		back() {
			this.parent.showFlag = true;
			if (this.type != 'info') {
				this.parent.search();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
</style>

